export default __webpack_public_path__ + "35e6e8d2287a996156dbc9f096969ab4.png";